import React                      from 'react'
import { DatePicker
       , Layout
       , Select }                 from 'antd'
import { Observer }               from 'mobx-react'

import { TEXT, tr_enum_job_state }                   from '../00_assets'
import { API_GENERAL_ERROR
       , JOB_STATUS
       , kde_api_job_t }          from '../02_api'
import { get_job_status_id
       , Toolbar
       , VerFormElement
       , VerFormInput }           from '../10_ui'

import { MJobs }                  from './01_screen_jobs_model'
import { JobsTable }              from './03_screen_jobs_table'


export const JobsScreen: React.FC = () =>
<Observer render={ ( ) =>
{
  const model = MJobs.instance( )
      , on_cancel_job = async ( job: kde_api_job_t ) =>
        {
          if ( job.jobStatus.name === JOB_STATUS.PENDING )
            {
               const job_status_id = await get_job_status_id( JOB_STATUS.CANCELLED ) ;
               
               return job_status_id !== false?
                      model.jobs.on_edit( job, { jobStatus: { id: job_status_id } } as any )
                    : API_GENERAL_ERROR( ) ;
            }
        }
      , src   = model.jobs.data_for_page( 0 )

  return <Layout.Content className="scrollable">
      <Toolbar>
        <VerFormElement
          label={ TEXT.JOB_FILTER_BY_STATUS }
          className="mr-3"
        >
          <Select
            style={{minWidth: 200}} 
            value={ model.filter_status }
            onChange={ model.on_change_filter_status }
          >
            {
              [ JOB_STATUS.UNDEFINED
              , JOB_STATUS.PENDING
              , JOB_STATUS.COMPLETE
              , JOB_STATUS.CANCELLED
              , JOB_STATUS.PROCESSING
              ].map( (status:string) =>
                <Select.Option value={ status } key={ status }>{ tr_enum_job_state( status ) }</Select.Option> )
            }
          </Select>
        </VerFormElement>

        <VerFormInput
          label={ TEXT.JOB_FILTER_BY_KEY_TYPE }
          className="mr-3"
          {...model.filter_model.bind}
        />

        <VerFormElement
          label={ TEXT.JOB_FILTER_BY_DATE }
          className="mr-3"
        >
          <DatePicker 
            {...model.filter_date.bind}
          />
        </VerFormElement>
      </Toolbar>
      <JobsTable
        loading={ src.loading }
        jobs={ src.data.slice( 0 ) }
        onDelete={ on_cancel_job }
        onEdit={ model.jobs.on_edit }
        onAdd={ model.jobs.on_add }
      />
   </Layout.Content> ;
} }/>